import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { getSelectList, handleMultiSelect } from '../../../config/utils';
import { useSelector } from 'react-redux';
import { fetchCompanyFilters } from '../../../store/actions/rateCard';
import {
  getAllSellersList
} from "../../../store/actions";

const BarcodeListingFilter = (props) => {
  const {
    handleReset,
    fetchBarcodeDataList,
    dispatch,
    filterData,
    setfilterData
  } = props;
  const [companyList, setCompanyList] = useState([]);
  const [sellerList, setSellerList] = useState([]);
  const { filterCompanies } = useSelector((state) => state.RateCardReducer);
  const UserValue = useSelector((state) => state.auth.user);

  useEffect(() => {
    /* istanbul ignore next */
    let companyList =
      filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
    if (companyList.length) {
      if (UserValue?.Value?.isSuperAdmin === true) {
        setCompanyList(
          getSelectList(
            filterCompanies?.Entity?.listCompanyMasterOrdersEntity,
            "Id",
            "name"
          )
        );
      } else {
        let filterCompany = companyList.filter(
          (company) =>
            company.name.toLowerCase() ===
            UserValue?.Value?.companyName.toLowerCase()
        );
        setCompanyList(getSelectList(filterCompany, "Id", "name"));
      }
    }
  }, [filterCompanies]);

  /* istanbul ignore next */
  const fetchSellers = async (companyList) => {
    let data = {
      companyIds: companyList,
    };
    let res = await getAllSellersList(data);
    if (res?.data?.Status === 200) {
      let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
        (item) => {
          return {
            ...item,
            label: item.sellerAndCompany,
            value: item.id,
          };
        }
      );
      setSellerList(dataList);
    }
  };

  useEffect(() => {
    let data = {
      pageIndex: 1,
      pageSize: 10,
      sortColumn: "name",
      sortOrder: "ascending",
    };
    dispatch(fetchCompanyFilters(data));
  }, []);

  return (
    <div className="filterContainer show historyFilter barcode history-margin">
      <div className="row mb10">
        <div className="col-3">
          <div className="row">
            <div className="col-12">
              <label className="labelHead">Company</label>
            </div>
            <div className="col-12">
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={companyList}
                classNamePrefix="list"
                id="companyIdList"
                name="companyIdList"
                value={filterData?.companyIdList}
                onChange={(value) => handleMultiSelect(value, "companyIdList", filterData, setfilterData, 'companyIdList', 'sellerIdList', fetchSellers)}
              />
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="row">
            <div className="col-12">
              <label className="labelHead">Seller</label>
            </div>
            <div className="col-12">
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={sellerList}
                classNamePrefix="list"
                id="sellerIdList"
                name="sellerIdList"
                value={filterData?.sellerIdList}
                onChange={(value) => handleMultiSelect(value, "sellerIdList", filterData, setfilterData, 'companyIdList', 'sellerIdList', fetchSellers)}
              />
            </div>
          </div>
        </div>

        <div className="col-2">
          <div className="row">
            <div className="col-12">
              <label className="labelHead"></label>
            </div>
            <div className="col-12 flexEnd">
              <button
                className="btn cus-primary-transparent-btn top-btn clearBtn"
                onClick={(e) => handleReset(e, "clear")}
              >
                Clear Filter
              </button>
              <button
                className="cus-seconday-bg-btn btn filterBtn"
                onClick={() => fetchBarcodeDataList()}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BarcodeListingFilter;